import MicroModal from 'micromodal';
import validator from 'validator';

let inputBars = document.getElementById("inputBars");
let bars = document.getElementsByClassName("c-bars__bar");
let fase = document.getElementById("fases");
let fases = [
	"De 3 a 6 meses",
	"De 6 meses a 1 año",
	"De 1 a 2 años",
	"De 2 a 3 años",
	"De 3 a 4 años",
	"De 4 a 5 años",
	"De 5 a 6 años",
	"De 6 a 7 años"
]

let clearTooltips = function(){
	for (let i=0; i < bars.length ; i++) {
		bars[i].classList.remove("c-bars__bar--show-tip");
	}
}

let progressFill = function(el){
	var value = (el.value-el.min)/(el.max-el.min)*100
	el.style.background = `linear-gradient(to right, #dc0028 0%, #dc0028 ${value}%, #ebebeb  ${value}%, #ebebeb 100%)`
}
if(inputBars){
	inputBars.addEventListener('input', function(e) {
		let actualNumber = e.target.value - 1;
		let previousNumber = 0;
		for (let i=0; i <= actualNumber; i++) {
			previousNumber = i + 1;
			bars[previousNumber-1].classList.add("c-bars__bar--completed");
			clearTooltips();
			bars[actualNumber].classList.add("c-bars__bar--show-tip");
		}
		for (let i=0;i < bars.length; i++ ) {
			if(i > actualNumber) {
				bars[i].classList.remove("c-bars__bar--completed");
			}
		}
		progressFill(this);
		fase.innerHTML = "<strong> Fase " + (actualNumber + 1) + "</strong>" + fases[actualNumber];
	});
}


let tooltipApear = function() {
	let actualNumber = 0;
	for (let i = 0; i < bars.length; i++ ) {
		bars[i].addEventListener('mouseover',function(e){
			clearTooltips();
			this.classList.add("c-bars__bar--show-tip");
		})
		bars[i].addEventListener('click',function(e){
			inputBars.value= i + 1;
			progressFill(inputBars);
			actualNumber = inputBars.value= i+1;
			let previousNumber = 0;
			for (let i=0; i < actualNumber; i++) {
				previousNumber = i;
				bars[previousNumber].classList.add("c-bars__bar--completed");
				clearTooltips();
				bars[actualNumber-1].classList.add("c-bars__bar--show-tip");
			}
			for (let i=1;i < bars.length; i++ ) {
				if(i >= actualNumber) {
					bars[i].classList.remove("c-bars__bar--completed");
				}
			}

			clearTooltips();
			this.classList.add("c-bars__bar--show-tip");
			fase.innerHTML = "<strong> Fase " + (actualNumber) + "</strong>" + fases[actualNumber - 1];
		})
	}
}

tooltipApear();

// modals
let closeVideo = document.getElementById('closeVideo');
let videoFrame = document.getElementById('videoFrame');
let homePlayVideo = document.getElementById('homePlayVideo');
let playVideoLink = document.getElementById('playVideoLink');
if(videoFrame && homePlayVideo && playVideoLink){
	let getVideoUrl = videoFrame.src;
	homePlayVideo.addEventListener('click', function(){videoFrame.src=getVideoUrl})
	playVideoLink.addEventListener('click', function(){videoFrame.src=getVideoUrl})
	let pauseVideo = function(){
		videoFrame.src=""
	}
	MicroModal.init(
		{	
			onShow: modal =>{
				if(modal.id === "modal-form"){
					if(document.getElementById('modal-video').classList.contains('is-open')){
						MicroModal.close('modal-video');
					}
					document.querySelector('.c-header').classList.add('hidden-button')
				}else if(modal.id === "modal-video"){
					if(document.getElementById('modal-form').classList.contains('is-open')){
						MicroModal.close('modal-form');
					}
					document.querySelector('.c-header').classList.add('visible-button')
				}
			},
			onClose: modal => {
				pauseVideo()
				if(modal.id === "modal-form"){
					document.querySelector('.c-header').classList.remove('hidden-button')
				}else if(modal.id === "modal-video"){
					document.querySelector('.c-header').classList.remove('visible-button')
				}
			}
		}
	)
}else{
	MicroModal.init(
		{
			onShow: modal =>{
				if(modal.id === "modal-form"){
					if(document.getElementById('modal-video').classList.contains('is-open')){
						MicroModal.close('modal-video');
					}
					document.querySelector('.c-header').classList.add('hidden-button')
				}else if(modal.id === "modal-video"){
					if(document.getElementById('modal-form').classList.contains('is-open')){
						MicroModal.close('modal-form');
					}
					document.querySelector('.c-header').classList.add('visible-button')
				}
			},
			onClose: modal => {
				if(modal.id === "modal-form"){
					document.querySelector('.c-header').classList.remove('hidden-button')
				}else if(modal.id === "modal-video"){
					document.querySelector('.c-header').classList.remove('visible-button')
				}
			}
		}
	);
}

// validate form modal
/* let homeFormModal = document.getElementById('homeFormModal');
let inputNameSurnameModal = document.getElementById('inputNameSurnameModal');
let inputSurnameModal = document.getElementById('inputSurnameModal');
let inputEmailModal = document.getElementById('inputEmailModal');
let inputPhoneModal = document.getElementById('inputPhoneModal');
let inputPosCodeModal = document.getElementById('inputPosCodeModal');
let buttonHomeFormModal = document.getElementById('buttonHomeFormModal');
let selectStudiesModal = document.getElementById('selectStudiesModal');
let selectStudiesMessageModal = document.getElementById('selectStudiesMessageModal');
let checkboxTermsModal = document.getElementById('checkboxTermsModal');
let checkboxMessageModal = document.getElementById('checkboxMessageModal');
let fileLabelModal = document.getElementById('fileLabelModal');

let validateFormModal = function(e) {
	let validationArr = {
		name: false,
		surname: false,
		mail: false,
		phone: false,
		zipcode: false,
		studies: false,
		cv: false, 
		check: false
	}
	e.preventDefault();
	checkboxMessageModal.style.display='none'
	selectStudiesMessageModal.style.display='none'
	inputUploadCvMessageModal.style.display='none'
	inputUploadCvModal.classList.remove('error');
	selectStudiesModal.classList.remove('error');
	checkboxTermsModal.classList.remove('error');
	let verify = function(el,test,type) {
		console.log(el);
		let returnBool = true;
		el.classList.remove('error');
		document.querySelector(`.${el.id}.c-input__empty-text`).style.display='none';
		document.querySelector(`.${el.id}.c-input__error-text`).style.display='none';
		if (validator.isEmpty(el.value) == true){
			el.classList.add('error');
			document.querySelector(`.${el.id}.c-input__error-text`).style.display='none';
			document.querySelector(`.${el.id}.c-input__empty-text`).style.display='block';
			el.focus();
			returnBool = false;
		}
		else if (test && validator[test](el.value) != true){
			el.classList.add('error');
			document.querySelector(`.${el.id}.c-input__empty-text`).style.display='none';
			document.querySelector(`.${el.id}.c-input__error-text`).style.display='block';
			el.focus();
			returnBool = false;
		}
		return returnBool;
	}
	if(checkboxTermsModal.checked == false) {
		checkboxMessageModal.style.display='block'
		checkboxTermsModal.classList.add('error');
	}else{
		validationArr.check = true;
	}
	if(selectStudiesModal.value == "") {
		selectStudiesMessageModal.style.display='block'
		selectStudiesModal.classList.add('error');
	}else{
		validationArr.studies = true;
	}
	let dotIndex = inputUploadCvModal.value.toString().lastIndexOf('.') + 1;
	if(inputUploadCvModal.value == "" || inputUploadCvModal.value.toString().substring(dotIndex) != "pdf") {
		inputUploadCvMessageModal.style.display='block'
		inputUploadCvModal.classList.add('error');
	}else{
		validationArr.cv = true;
	}

	validationArr.mail = verify(inputEmailModal,"isEmail",true);
	validationArr.phone = verify(inputPhoneModal,"isNumeric");
	validationArr.name = verify(inputNameModal);
	validationArr.surname = verify(inputSurnameModal)
	validationArr.zipcode = verify(inputPosCodeModal,"isNumeric","postCode");
	if(!Object.values(validationArr).includes(false)){
		MicroModal.close('modal-form');
		MicroModal.show('modal-form-success');
	}
}
if(buttonHomeFormModal){
	buttonHomeFormModal.addEventListener('click', function(e){validateFormModal(e)});
}  */


let inputUploadCvModal = document.getElementById('inputUploadCvModal');
let inputUploadCvMessageModal = document.getElementById('inputUploadCvModalMessage');
let inputUploadCvButtonModal = document.getElementById('inputUploadCvButtonModal');
if(inputUploadCvButtonModal){
	inputUploadCvButtonModal.addEventListener('click', function(e){e.preventDefault(),this.dispatchEvent(inputUploadCvModal.click);})
}



// validate form
/* let homeForm = document.getElementById('homeForm');
let inputName = document.getElementById('inputName');
let inputSurname = document.getElementById('inputSurname');
let inputEmail = document.getElementById('inputEmail');
let inputPhone = document.getElementById('inputPhone');
let inputPosCode = document.getElementById('inputPosCode');
let buttonHomeForm = document.getElementById('buttonHomeForm');
let selectStudies = document.getElementById('selectStudies');
let selectStudiesMessage = document.getElementById('selectStudiesMessage');
let checkboxTerms = document.getElementById('checkboxTerms');
let checkboxMessage = document.getElementById('checkboxMessage');
let fileLabel = document.getElementById('fileLabel');

let validateForm = function(e) {
	let validationArr = {
		name: false,
		surname: false,
		mail: false,
		phone: false,
		zipcode: false,
		studies: false,
		cv: false, 
		check: false
	}
	e.preventDefault();
	checkboxMessage.style.display='none'
	selectStudiesMessage.style.display='none'
	inputUploadCvMessage.style.display='none'
	inputUploadCv.classList.remove('error');
	selectStudies.classList.remove('error');
	checkboxTerms.classList.remove('error');
	let verify = function(el,test,type) {
		let returnBool = true;
		el.classList.remove('error');
		document.querySelector(`.${el.id}.c-input__empty-text`).style.display='none';
		document.querySelector(`.${el.id}.c-input__error-text`).style.display='none';
		if (validator.isEmpty(el.value) == true){
			el.classList.add('error');
			document.querySelector(`.${el.id}.c-input__error-text`).style.display='none';
			document.querySelector(`.${el.id}.c-input__empty-text`).style.display='block';
			el.focus();
			returnBool = false;
		}
		else if (test && validator[test](el.value) != true){
			el.classList.add('error');
			document.querySelector(`.${el.id}.c-input__empty-text`).style.display='none';
			document.querySelector(`.${el.id}.c-input__error-text`).style.display='block';
			el.focus();
			returnBool = false;
		}
		return returnBool;
	}
	if(checkboxTerms.checked == false) {
		checkboxMessage.style.display='block';
		checkboxTerms.focus();
		checkboxTerms.classList.add('error');
	}else{
		validationArr.check = true;
	}
	let dotIndex = inputUploadCv.value.toString().lastIndexOf('.') + 1;
	if(inputUploadCv.value == "" || inputUploadCv.value.toString().substring(dotIndex) != "pdf") {
		inputUploadCvMessage.style.display='block';
		inputUploadCv.focus();
		inputUploadCv.classList.add('error');
	}else{
		validationArr.cv = true;
	}
	if(selectStudies.value == "") {
		selectStudiesMessage.style.display='block';
		selectStudies.focus();
		selectStudies.classList.add('error');
	}else{
		validationArr.studies = true;
	}

	validationArr.zipcode = verify(inputPosCode,"isNumeric","postCode");
	validationArr.phone = verify(inputPhone,"isNumeric");
	validationArr.mail = verify(inputEmail,"isEmail",true);
	validationArr.name = verify(inputName);
	validationArr.surname = verify(inputSurname);
	if(!Object.values(validationArr).includes(false)){
		MicroModal.show('modal-form-success');
	}
}
if(buttonHomeForm){
	buttonHomeForm.addEventListener('click', function(e){validateForm(e)});
}  */


let inputUploadCv = document.getElementById('inputUploadCv');
let inputUploadCvMessage = document.getElementById('inputUploadCvMessage');
let inputUploadCvButton = document.getElementById('inputUploadCvButton');
if(inputUploadCvButton){
	inputUploadCvButton.addEventListener('click', function(e){e.preventDefault(),this.dispatchEvent(inputUploadCv.click);})
}

var lastScrollTop = 0;

var hero = document.querySelector('.c-hero');
var header = document.querySelector('.c-header');
if(hero){
	window.addEventListener("scroll", function(){
		if(isElementInViewport(hero, header.clientHeight)){
			if(header.classList.contains('c-header--shadow')){
				header.classList.remove('c-header--shadow');
				header.querySelector('.c-link-button').classList.add('c-link-button--hidden');
			}
		}else{
			if(!header.classList.contains('c-header--shadow')){
				header.classList.add('c-header--shadow');
				header.querySelector('.c-link-button').classList.remove('c-link-button--hidden');
			}
		}
	}, false);
}else{
	header.querySelector('.c-link-button').classList.remove('c-link-button--hidden');
	window.addEventListener("scroll", function(){
		if(window.scrollY < header.clientHeight){
			if(header.classList.contains('c-header--shadow')){
				header.classList.remove('c-header--shadow');
			}
		}else{
			if(!header.classList.contains('c-header--shadow')){
				header.classList.add('c-header--shadow');
			}
		}
	}, false);
}

function isElementInViewport (el, offset) {
    var rect = el.getBoundingClientRect();
	let result = (Math.abs(rect.top) <= el.clientHeight - offset);
    return result;
}

//Accordion controls

var accordionTriggers =  document.querySelectorAll('.c-accordion-module__trigger');
if(accordionTriggers.length > 0){
	for(let trigger of accordionTriggers){
		trigger.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();
			let accordionItem = trigger.closest('.c-accordion-module__accordion-block');
			if(accordionItem.classList.contains('c-accordion-module__accordion-block--open')){
				accordionItem.classList.remove('c-accordion-module__accordion-block--open');
			}else{
				let accordionItems = trigger.closest('.c-accordion-module').querySelectorAll('.c-accordion-module__accordion-block');
				for(let item of accordionItems){
					if(item !== accordionItem && item.classList.contains('c-accordion-module__accordion-block--open')){
						item.classList.remove('c-accordion-module__accordion-block--open');
					}else if(item === accordionItem){
						accordionItem.classList.add('c-accordion-module__accordion-block--open');
					}
				}	
			}
		})
	}
}

//Superagente

var observer = new IntersectionObserver(function(entries) {
	if(entries[0].isIntersecting === true){
		var order = entries[0].target.dataset.order;
		if(order == 1){
			document.querySelector("#thumb-1").classList.add("active");
			document.querySelector(".phase-1").classList.add("active");
		}else if(order == 2){
			document.querySelector("#thumb-2").classList.add("active");
			document.querySelector(".phase-2").classList.add("active");
		}else if(order == 3){
			document.querySelector("#thumb-3").classList.add("active");
			document.querySelector(".phase-3").classList.add("active");
		}else if(order == 4){
			document.querySelector(".phase-3").classList.add("office");
		}
	}
}, { threshold: [1] });

if(document.querySelector(".phase-1") && document.querySelector(".phase-2") && document.querySelector(".phase-3") && document.querySelector(".c-timeline__oficina")){
	observer.observe(document.querySelector(".phase-1"));
	observer.observe(document.querySelector(".phase-2"));
	observer.observe(document.querySelector(".phase-3"));
	observer.observe(document.querySelector(".c-timeline__oficina img"));
}


// Input file

let selectFileUpdateName = function(inputId, labelId){
	const fileSelector = document.getElementById(inputId);
	const fileLabelReplace = document.getElementById(labelId);
	if(fileSelector){
		fileSelector.addEventListener('change', (event) => {
			fileLabelReplace.classList.add('active');
			const fileName = event.target.files[0].name;
			if(fileName.length > 40){
				fileLabelReplace.innerText = fileName.substring(0, 40) + '...';
			}else{
				fileLabelReplace.innerText = fileName;
			}
		});
	}
}

selectFileUpdateName('inputUploadCv', 'fileLabel');
selectFileUpdateName('inputUploadCvModal', 'fileLabelModal')